import { render, staticRenderFns } from "./RightsImageViewer.vue?vue&type=template&id=0bf2f0b1&scoped=true"
import script from "./RightsImageViewer.vue?vue&type=script&lang=js"
export * from "./RightsImageViewer.vue?vue&type=script&lang=js"
import style0 from "./RightsImageViewer.vue?vue&type=style&index=0&id=0bf2f0b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf2f0b1",
  null
  
)

export default component.exports